import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DateRange, DateTimeRangePicker } from '@mui/x-date-pickers-pro';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV2';

import { getLocale } from '@/components/common/translateFunctions';
import { localeText } from './DateRangeSelectBase';
import { isValidDate } from '@/utilities/dateUtils';

import './DateTimeSelect.css';

export function DateTimeRangeSelect({
  setSelectedDates,
  startDate,
  endDate,
  minDateTime,
}: {
  setSelectedDates: (from: Date, to: Date) => void;
  startDate: Date | null;
  endDate: Date | null;
  minDateTime?: Date | undefined;
}) {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  function onAccept(newValue: DateRange<Date>) {
    if (!newValue[0] || !newValue[1] || !isValidDate(newValue[0]) || !isValidDate(newValue[1])) {
      return;
    }

    if (newValue[0].getTime() > newValue[1].getTime()) {
      setSelectedDates(newValue[1], newValue[0]);
    } else {
      setSelectedDates(newValue[0], newValue[1]);
    }
  }

  const localeLanguage = getLocale(i18n.language);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={localeLanguage}>
      <DateTimeRangePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        className="mui-datetime-selector"
        minDate={minDateTime}
        defaultValue={[startDate, endDate]}
        onAccept={onAccept}
        timeSteps={{ minutes: 1 }}
        localeText={localeText(t)}
        disableOpenPicker
        slots={{
          toolbar: undefined,
        }}
        slotProps={{
          layout: {
            className: 'target-share-picker',
          },
          field: {
            readOnly: true,
            onClick: () => setOpen(true),
          },
        }}
      />
    </LocalizationProvider>
  );
}
